import { render, staticRenderFns } from "./SignupLayout.vue?vue&type=template&id=41784121&"
import script from "./SignupLayout.vue?vue&type=script&lang=js&"
export * from "./SignupLayout.vue?vue&type=script&lang=js&"
import style0 from "./SignupLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports